<template>
  <LoginPage bm-journey="seller" redirection-pathname="/bo-seller/login" />
</template>

<script lang="ts" setup>
import LoginPage from '@backmarket/nuxt-layer-oauth/LoginPage.vue'
</script>
